export default {
  PAYMENT_API_URL: 'https://payment-preprod.circlechess.cc',
  CHAT_API_URL: 'https://chatbot-preprod.circlechess.cc',
  ANALYZE_GAME_API_URL:
    'https://chess-preprod.circlechess.cc/game/start_analyzing_game',
  CHESS_API_URL: 'https://chess-preprod.circlechess.cc',
  DEBUG_ENABLED: true,
  FARO_URL: 'https://faro.circlechess.cc/collect',
  // PlayChess V2 rollout gate: 'off' | 'staff' | 'flag' | 'all' — 'flag' = users
  // with cc_user_flags.play_v2 = 1 (flag only, staff included); see Screens/PlayChessSwitch/playFlags.
  PLAY_V2_COHORT: 'flag',
  // Lobby A/B (M2): %% of users who get the 'gallery' home; the rest get
  // 'classic'. Per-user override: ?lobby=classic|gallery (localStorage
  // cc_lobby_variant) -- see Screens/PlayChessV2/pages/home/resolveLobbyVariant.
  LOBBY_GALLERY_PCT: 0,
  API_KEY: '2d30f638-8922-4d8a-bb77-e25ad4af0aed',
  X_API_KEY: '2d30f638-8922-4d8a-bb77-e25ad4af0aed',
  GAME_SERVICE_URL: 'wss://game-service-preprod.circlechess.cc',
  CAISSA_CHATBOT_API: 'https://65.1.214.145',
  TOURNAMENT_API_URL: 'https://cc-event-preprod.circlechess.cc/api',
  //For Superset //staging server
  SUPERSET_URL: 'https://pp-superset.circlechess.com',
  SUPERSET_USERNAME: 'admin',
  SUPERSET_PASSWORD: 'ccadmin',
  // Zoom
  ZOOM_IFRAME_BASE_URL: 'https://pp-learn.circlechess.cc/zoom',
  ZOOM_IFRAME_BASE_EXIT_URL: 'https://pp-learn.circlechess.cc/zoom',
  ZOOM_CLIENT_ID: 'd2KzP4bHTTyufHvlIm6OwA',
  LICHESS_EXPLORER_TOKEN: 'lip_ER7vmduwNzHkFfl1TJh2',
  PUZZLE_ENC_KEY: 'f29fc7b0eaa2e1f935988a662fedc82d',

  // study
  EXPLORER_MASTERS_BASE_URL: 'https://opening-explorer-nonprod.circlechess.cc/masters',
  TABLEBASE_BASE_URL: 'https://tablebase-nonprod.circlechess.cc',
  // WAF_CHALLENGE_SCRIPT_URL: 'https://68ed58a14954.ap-south-1.captcha-sdk.awswaf.com/68ed58a14954/jsapi.js', // replaced by Turnstile
  // WAF_COOKIE_DOMAIN: 'circlechess.cc', // replaced by Turnstile
  TURNSTILE_SITE_KEY: '0x4AAAAAAFDTpXc5gcCE8hvs',
};
